<template>
    <div
        tabindex="-1"
        aria-labelledby="offcanvasAddUserLabel"
    >
        <div class="offcanvas-header border-bottom">
            <h5 id="offcanvasAddUserLabel" class="offcanvas-title">
                FORM P2H SARANA 
            </h5>
        </div>
        <div class="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
            <div class="col-xl">
                <form
                    @submit.prevent="send"
                    autocomplete="off"
                    autocapitalize="on"
                >
                    <div class="mb-3">
                        <label class="form-label" for="nomorLambung"
                            >UNIT SARANA (LIGHT VEHICLES)
                        </label>
                        <input
                            type="hidden"
                            name="_token"
                            v-model="csrfTokens"
                        />
                        <select
                            class="form-control"
                            id="nomorLambung"
                            name="kodeUnit"
                            placeholder="NOMOR LAMBUNG"
                            @change="selectSarana($event)"
                            required="required"
                            v-model="p2hSarana.kodeUnit"
                        >
                        <option value="" selected="selected">-- Pilih --</option>
                        <option  v-for="(i,k) in sarana" :value="k"> {{ i }}</option>
                    </select>
                    </div>

                    <div class="mb-3">
                        <label class="form-label" for="merkType">MEREK - Type</label>
                        <input
                            type="text"
                            class="form-control"
                            id="merkType"
                            v-model="p2hSarana.merkType"
                            placeholder="MEREK - Type"
                            required="required"
                            readonly="readonly"
                        />
                    </div>
                    <div class="mb-3">
                        <label class="form-label" for="shfit"
                            >SHIFT</label
                        >
                        <div class="col-md" >
                        <div class="form-check form-check-inline mt-3" v-for="choice in choices" :key="choice">
                            <input
                              class="form-check-input"
                              type="radio"
                              :name="'shift_'+choice"
                              :id="'shift-'+choice"
                              :value="choice"
                              v-model="p2hSarana.shift"
                              
                              @change="showCheckedValue"
                            />
                            <label class="form-check-label" :for="'shift-'+choice">SHIFT {{ choice }}</label>
                          </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label class="form-label" for="warna">Kilometer</label>
                        <input
                            type="text"
                            class="form-control"
                            id="kilometer"
                            v-model="p2hSarana.kilometerUnit"
                            placeholder="Kilometer"
                            required="required"
                            @keypress="isNumber($event)"

                        />
                    </div>
                    <hr>
                    <center>
                        <b>
                            Tabel List P2H
                        </b>
                    </center>
                    <div class="mb-12">
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr class="text-center">
                                        <th>NO</th>
                                        <th>PEMERIKSAAN AWAL KEGIATAN</th>
                                        <th>AKSI</th>
                                    </tr>
                                </thead>
                                <tfoot>
                                    <tr class="text-center">
                                        <th>NO</th>
                                        <th>PEMERIKSAAN AWAL KEGIATAN</th>
                                        <th>AKSI</th>
                                    </tr>
                                </tfoot>
                                <tbody>
                                    <tr v-for="(a , b) in p2hItems">
                                        <td > 
                                            <span v-if="(a['nomor'])">{{ a['nomor'] }}</span> 
                                            <span v-else>-</span> 
                                        </td>
                                        <td>
                                            <span v-if="(a['title'])">
                                                {{ a['title'] }}
                                            </span>
                                            <span v-else>
                                                {{ a['item'] }} 
                                            </span>
                                        </td>
                                        <td>
                                            <span v-if="(!a['title'])">
                                                <button class="btn btn-xs btn-primary" type="button" data-bs-toggle="modal"
                                                data-bs-target="#basicModal" 
                                                @click="adaPilih(
                                                a['item'],
                                                a['idP2hList'],
                                                a['idP2hItem'],
                                                'baik',b)"
                                                >Pilih</button>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <button
                        type="submit"
                        class="btn btn-primary me-3 data-submit"
                    >
                        Submit
                    </button>
                    <button
                        type="reset"
                        class="btn btn-outline-danger"
                        data-bs-dismiss="offcanvas"
                    >
                        Cancel
                    </button>
                </form>
            </div>
        </div>
        <div class="modal fade" id="basicModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel1">{{this.pilihan.item}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    
                </div>
                <div class="modal-body">
                    
                    <div class="row">
                        <div class="col mb-12" style="vertical-align: middle;text-align: center;" >
                            <label for="nameBasic" class="form-label">Ketersediaan</label>
                        <div class="col-md-12" >
                        <div class="form-check form-check-inline mt-6">
                            <input type="radio" class="form-check-input" name="adaTidak" id="baik" value="baik" > 
                                &nbsp;
                                <label class="form-label" for="baik">
                                    BAIK
                                </label>
                                
                        </div>
                        <div  class="form-check form-check-inline mt-6">
                            <input type="radio" class="form-check-input" name="adaTidak" id="tidak" value="baik" > 
                                &nbsp;
                                <label class="form-label" for="tidak">
                                    TIDAK
                                </label>
                        </div>
                        </div>
                        <div class="col-md-12" >
                            <hr>
                        </div>
                    </div>
                    </div>

                    <div class="row">
                        <div class="col mb-12" style="vertical-align: middle;text-align: center;" >
                            <label for="nameBasic" class="form-label">Kondisi</label>
                        

                        <div class="col-md-12" >
                        <div class="form-check form-check-inline mt-6">
                            <input type="radio" class="form-check-input" name="adaTidak" id="baik" value="baik" > 
                                &nbsp;
                                <label class="form-label" for="baik">
                                    BAIK
                                </label>
                                
                        </div>
                        <div  class="form-check form-check-inline mt-6">
                            <input type="radio" class="form-check-input" name="adaTidak" id="tidak" value="baik" > 
                                &nbsp;
                                <label class="form-label" for="tidak">
                                    TIDAK
                                </label>
                        </div>
                        </div>
                        <div class="col-md-12" >
                        <hr>    
                        </div>
                    </div>
                    </div>

                    <div class="row">
                        <div class="col mb-12" style="vertical-align: middle;text-align: center;" >
                            <label for="nameBasic" class="form-label">Keterangan</label>
                        
                        <div class="col-md-12" >
                            <textarea name="keterangan" id="keterangan" class="form-control" placeholder="Keterangan "></textarea>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
                        Close
                    </button>
                    <button type="button" class="btn btn-primary">Save changes</button>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
import axios from "axios";
import { ref, reactive } from "vue";

export default {
    mounted() {

        if (this.username != "")
            this.users = JSON.parse(this.username)
        if(this.uidform!=null) this.p2hSarana.uidform=this.uidform
        this.p2hSarana.shift=1
        this.getSarana()
        if(this.idsarana!=null) this.p2hSarana.kodeUnit=this.idsarana
        this.choices = reactive([
                                '1',
                                '2',
                                ])
        this.getP2hList()
        this.createForm()
    },
    data() {
        return {
            strTime:new Date(),
            urlAction: "/",
            csrfTokens: "",
            sarana: {},
            vehicle: {},
            p2hSarana:{},
            idVehicles: null,
            choices:null,
            p2hItems:{},
            indexV:1,
            pilihan:{}
        };
    },
    props: ["tokens", "url_action","idsarana","uidform","username"],
    methods: {
        send(){
            console.table(this.p2hSarana)
        },
        getSarana() {
            axios
                .get("/sarana/lv/show")
                .then((response) => {
                    var v = response.data;
                    if (v != null) {
                        var s = {};
                        var vhc = {};
                        for(var i in v){
                            s[v[i].uidVehicle] = v[i].noLambung + " ("+v[i].noPol+")"
                            vhc[v[i].uidVehicle]= v[i].merek + " ("+v[i].type+")"
                        }
                        this.sarana = s
                        this.vehicle = vhc
                    }
                    this.changeSarana(this.p2hSarana.kodeUnit)
                });
        },
        selectSarana(e){
            var v = this.vehicle[e.target.value]
            this.p2hSarana.noLambung = this.sarana[e.target.value];
            this.p2hSarana.merkType = v
            this.p2hSarana.kodeUnit = e.target.value;
        },
        changeSarana(e){
            var v = this.vehicle[e]
            this.p2hSarana.noLambung = this.sarana[e];
            this.p2hSarana.merkType = v
            this.p2hSarana.kodeUnit = e;
        },
        showCheckedValue(e){
            console.log("Shift : "+e.target.value)
        },
        
        
        isNumber(evt) {
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57)
            ) {
                evt.preventDefault();
            }
        },
        getP2hList(){
            var z=1;
            axios
            .get("/sarana/p2h/create")
            .then((r)=>{
                this.p2hItems = r.data
            })
        },

        kondisiPilihan(a,b,c,d){
        },
        adaPilih(a,b,c,d,e){
            console.log("a : "+a+" b : "+b+" c : "+c," d: "+d+" e: "+e)
            var username = this.users.username
            this.p2hSarana.uidform
            this.pilihan = {
                "uidP2h":this.p2hSarana.uidform,
                "listIdP2h":b,
                "itemIdP2h":c,
                "userInput":username,
                "item":a
            }
            // this.checkListAdd({
            //     "uidP2h":this.p2hSarana.uidform,
            //     "listIdP2h":b,
            //     "itemIdP2h":c,
            //     "userInput":username
            // })
        },
        
        checkListAdd(data){
            axios
                .post("/sarana/p2h/",data)
                .then((res)=>{
                    if(res!=null){
                        var data = res.data
                        var count = data.result
                        var fetch = data.fetch

                        if(count>0){
                            this.p2hSarana.uidform = fetch.uidP2h
                            console.log("B : "+this.p2hSarana.uidform)
                        }else{
                            console.log("A : "+this.p2hSarana.uidform)

                        }
                    }
                })
        }, createForm(){
            var username = this.users.username
            axios
                .put("/sarana/p2h/"+this.p2hSarana.uidform,{"username":username})
                .then((res)=>{
                    if(res!=null){
                        var data = res.data
                        var count = data.result
                        var fetch = data.fetch

                        if(count>0){
                            this.p2hSarana.uidform = fetch.uidP2h
                            console.log("B : "+this.p2hSarana.uidform)
                        }else{
                            console.log("A : "+this.p2hSarana.uidform)

                        }
                    }
                })
        }
    },
};
</script>
